import { offersRetentionGift, type CancellationReason } from "../../../shared/cancellation_reasons.js";

/**
 * The Zenlinks for some months instead of cancelling (PIT-54): what Zenpost offers in the
 * cancel-rescue context, null when the customer has it or already got it.
 */
export interface RetentionOffer {
  key: string;
  name: string;
  months: number;
}

export type RetentionGiftState = "idle" | "accepting" | "accepted" | "unavailable";

/**
 * Whether the confirm screen opens with the gift card: only for the reasons it answers (not using
 * it; price when no cheaper plan is on offer), only when Zenpost offers it, and not once Zenpost
 * said it is no longer available. `cheaperPlanOptions` is how many cheaper-plan options the page
 * priced, null while it is still pricing them.
 */
export function showsRetentionGift(args: {
  reason: CancellationReason | null;
  offer: RetentionOffer | null;
  state: RetentionGiftState;
  cheaperPlanOptions: number | null;
}): boolean {
  return (
    Boolean(args.offer) &&
    offersRetentionGift(args.reason, { cheaperPlanOptions: args.cheaperPlanOptions }) &&
    args.state !== "unavailable"
  );
}
